import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import {
  Inject,
  Injectable,
  Optional,
  PLATFORM_ID,
  REQUEST,
} from '@angular/core';
import { StorageEngine } from '@ngxs/storage-plugin';

@Injectable()
export class CookieStorageEngine implements StorageEngine {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject(REQUEST) private request: Request, // Inject the request object
  ) {}

  private getCookieString(): string {
    if (isPlatformServer(this.platformId)) {
      return this.request?.headers?.get('cookie') || '';
    }

    return document.cookie;
  }

  getItem(key: string): string | null {
    const cookieString = this.getCookieString();
    const cookie = cookieString
      .split('; ')
      .find((row) => row.startsWith(`${key}=`));
    if (!cookie) {
      return null;
    }

    try {
      return JSON.parse(decodeURIComponent(cookie.split('=')[1]));
    } catch (error) {
      console.error('Error parsing cookie:', error);
      return null;
    }
  }

  setItem(key: string, value: any): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const encodedValue = encodeURIComponent(JSON.stringify(value));
    const date = new Date();
    date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
    document.cookie = `${key}=${encodedValue};path=/;Secure;SameSite=Strict;Expires=${date.toUTCString()};`;
  }

  removeItem(key: string): void {
    this.deleteCookie(key);
  }

  clear(): void {
    // To clear all cookies, you can iterate over all cookies and delete them.
    if (isPlatformBrowser(this.platformId)) {
      const cookies = document.cookie.split(';');
      cookies.forEach((cookie) => {
        const key = cookie.split('=')[0].trim();
        this.deleteCookie(key);
      });
    }
  }

  private setCookie(key: string, value: string): void {}

  private deleteCookie(key: string): void {
    if (isPlatformBrowser(this.platformId)) {
      document.cookie = `${key}=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT;`;
    }
  }
}
